module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/gray_minus-dc5ab4e63cabab3573488c9c2a4924ab.png";